import { ReactNode, useSyncExternalStore } from 'react';
import TableRowCount from '@srm/ui/table-row-count';
import { createTableCountStore } from '@/context/DocumentTableCountContext';

const BlockTableCountHeader = ({
    store,
    children,
}: {
    store: ReturnType<typeof createTableCountStore>;
    children: ReactNode;
}) => {
    const entry = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
    return (
        <span className="document-block-table-title">
            <span className="document-block-table-title__name">{children}</span>
            {entry && <TableRowCount count={entry.count} label={entry.label} />}
        </span>
    );
};

export default BlockTableCountHeader;
